<form *ngIf="form"
	[formGroup]="form">
	<mat-form-field appearance="fill"
		class='mat-form-field--one-line mat-form-field--short'>
		<mat-label>
			{{'Name' | translate }}
		</mat-label>
		<input matInput
			formControlName="Name"
			required
			type="text">
		<mat-error *ngIf="f.Name.invalid && (f.Name.dirty || f.Name.touched)">
			{{'Name cannot be empty or longer than 128 characters' | translate }}
		</mat-error>
	</mat-form-field>

	<mat-form-field appearance="fill"
		class="mat-form-field--one-line mat-form-field--short">
		<mat-label>
			{{'Nitrate-N Concentration' | translate }}
		</mat-label>
		<input matInput
			id="NitrogenPPM"
			type="number"
			step="0.01"
			required
			formControlName="NitrogenPPM"/>
		<span matSuffix class="mat-form-field-suffix--padded">
			{{'ppm' | translate }}
		</span>

		<mat-error *ngIf="f.NitrogenPPM.invalid &&
			(f.NitrogenPPM.dirty || f.NitrogenPPM.touched)">
			{{'Not a valid number' | translate }}
		</mat-error>
	</mat-form-field>

	<mat-form-field appearance="fill"
		class="mat-form-field--one-line mat-form-field--short">

		<mat-label>
			{{'Electrical Conductivity' | translate }}
		</mat-label>
		<input matInput
			id="ElectricalConductivity"
			type="number"
			step="0.01"
			formControlName="ElectricalConductivity"/>
		<span matSuffix class="mat-form-field-suffix--padded">
			{{'dS/m' | translate }}
		</span>

		<mat-error *ngIf="f.ElectricalConductivity.invalid &&
			(f.ElectricalConductivity.dirty || f.ElectricalConductivity.touched)">
			{{'Not a valid number' | translate }}
		</mat-error>
	</mat-form-field>
</form>
